import React from 'react';

import Box from '@mui/material/Box';
import { circularProgressClasses } from '@mui/material/CircularProgress';

import Line from 'components/Icons/Line';

import { EntityRelatedActionsType } from 'utils/api/modules/entities/entities.types';

import { Cell, Container, StyledCircularProgress, TasksLabel } from './styles';

const EntityRelatedActionsCell: React.FunctionComponent<{
  relatedActions: EntityRelatedActionsType;
  /** Render for a caller's own layout rather than a grid row: no table-cell padding. */
  inline?: boolean;
}> = ({ relatedActions: { total, completed }, inline }): React.ReactElement => (
  // Cell is a MUI TableCell, which defaults to <td>. Every caller renders into a DataGrid cell or a
  // plain div, so the default logs a dev-only nesting warning on each of them.
  <Cell component="div" $inline={inline}>
    {total ? (
      <Container>
        <Box sx={{ position: 'relative' }}>
          <StyledCircularProgress value={100} sx={{ color: 'rgba(224, 224, 224, 1)' }} />
          <StyledCircularProgress
            data-testid="styled-circular-progress"
            value={(completed * 100) / total}
            sx={{
              position: 'absolute',
              left: 0,
              [`& .${circularProgressClasses.circle}`]: {
                strokeLinecap: 'round',
              },
            }}
          />
        </Box>

        <TasksLabel>
          {completed} / {total}
        </TasksLabel>
      </Container>
    ) : (
      <Container>
        <StyledCircularProgress value={100} sx={{ color: 'rgba(224, 224, 224, 1)' }} />
        <Line style={{ fontSize: '17px', marginLeft: '8px' }} />
      </Container>
    )}
  </Cell>
);

export default EntityRelatedActionsCell;
